import mainStyle from '@/less/main.less';
import { useStores } from '@/store';
import { getClipboardIcon } from '@/util';
import { observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-semantic-toasts';
import {
  Button,
  Form,
  FormField,
  FormGroup,
  Input,
  Segment,
  SegmentGroup,
} from 'semantic-ui-react';
import { SingleDatePicker } from '../SingleDatePicker';
import style from './onboarding-submission-details.less';

const segmentStyle = {
  boxShadow: 'none',
  background: 'transparent',
};

export const OnboardingSubmissionDetailsEmploymentInfo = observer(() => {
  const { temporaryEmployeeStore } = useStores();
  const [hireDateValue, setHireDateValue] = useState<Moment | null>(null);

  const occupation = temporaryEmployeeStore.current?.position?.label ?? '';

  useEffect(() => {
    if (temporaryEmployeeStore.current?.hireDate) {
      setHireDateValue(temporaryEmployeeStore.current.hireDate);
    }
  }, [temporaryEmployeeStore.current]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div>
        <Form className={style.form_container} style={{ width: '100%' }}>
          <SegmentGroup horizontal style={{ background: 'transparent' }}>
            <Segment style={segmentStyle}>
              <fieldset>
                <legend>EMPLOYMENT DATES</legend>
                <FormGroup inline className={style.form_group}>
                  <FormField width={16}>
                    <label htmlFor="hireDate" className={style.form_label} style={{ minWidth: 60 }}>
                      HIRE DATE
                    </label>
                    <SingleDatePicker
                      hideKeyboardShortcutsPanel
                      noBorder
                      block
                      id="startDate"
                      date={moment(hireDateValue)}
                      placeholder="May 16th, 2025"
                      onDateChange={(date) => setHireDateValue(date)}
                      isOutsideRange={() => false}
                      numberOfMonths={1}
                      displayFormat="MMM Do, YYYY"
                    />
                  </FormField>
                </FormGroup>
              </fieldset>
            </Segment>

            <Segment style={segmentStyle}>
              <fieldset>
                <legend>OCCUPATION</legend>
                <FormGroup inline className={style.form_group}>
                  <FormField width={16}>
                    <label
                      htmlFor="occupation"
                      className={style.form_label}
                      style={{ minWidth: 80 }}
                    >
                      OCCUPATION
                    </label>
                    <Input
                      id="occupation"
                      value={occupation}
                      icon={getClipboardIcon(occupation ?? '', 'Occupation')}
                      readOnly
                    />
                  </FormField>
                </FormGroup>
              </fieldset>
            </Segment>
          </SegmentGroup>
        </Form>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flex: 1,
        }}
      >
        <Button
          type="button"
          color="blue"
          className={mainStyle.confirm_button}
          onClick={async () => {
            if (hireDateValue && temporaryEmployeeStore.current?.id) {
              await temporaryEmployeeStore.update(
                { hireDate: hireDateValue },
                temporaryEmployeeStore.current.id,
              );
              toast({
                type: 'success',
                icon: 'check circle',
                title: 'Employment Info Updated',
                description: 'The employment info has been updated',
                time: 5000,
              });
            }
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
});
